class CustomBlend extends HTMLElement {
    constructor() {
        super();
        // beans
        this.beans = document.querySelectorAll('.animated-bean');

        // header elements
        this.announcmentBar = document.querySelector('#shopify-section-announcement-bar');
        this.siteHeader = document.querySelector('#site-header');
        this.footer = document.querySelector('#shopify-section-footer');
        this.footerBorder = document.querySelector('footer-borders');

        // navigation elements
        this.enterBtn = this.querySelector('#enter-btn');
        this.nextStep = this.querySelector('#next-step');
        this.previousStep = this.querySelector('#previous-step');

        this.nextText = this.querySelector('.navigation-next');
        this.addToCartText = this.querySelector('.navigation-add')
        
        // All step elements
        this.stepsContainer = this.querySelector('#steps-container');
        this.header = this.querySelector('#custom-blend-header')
        this.mobileSummary = this.querySelector('#summary-container-mobile');
        this.navigation = this.querySelector('#navigation-container');
        this.progress = this.querySelector('#progress-container');
        this.progressFill = this.querySelector('#progress-fill');
        this.progressBrewing = this.querySelector('.progress-bar__brewing');
        this.progressComplete = this.querySelector('.progress-bar__complete');
        this.summaryCount = this.querySelector('#summary-count');

        this.stepOneTitle = this.querySelector('#progress-step-1');
        this.stepTwoTitle = this.querySelector('#progress-step-2');
        this.stepThreeTitle = this.querySelector('#progress-step-3');
        this.stepFourTitle = this.querySelector('#progress-step-4');
        this.progressSteps = this.querySelectorAll('.progress-step');

        this.modalTriggers = this.querySelectorAll('.modal-trigger');
        this.modalBackground = this.querySelector('#modal-background');
        this.closeModals = this.querySelectorAll('.close-modal');
        this.startOver = this.querySelector('#start-over-btn');

        this.summaryTotal = this.querySelectorAll('.summary-total');
        this.subtotalContainers = this.querySelectorAll('.subtotal-container');

        //Mobile Summary
        this.mobileSummaryToggle = this.querySelector('#mobile-summary-toggle');
        this.mobileSummary = this.querySelector('#summary-container-mobile');
        this.mobileSummaryContent = this.querySelector('#summary-container-mobile-items');
        this.mobileSummaryInner = this.querySelector('#mobile-items-inner');

        //Steps
        this.intro = this.querySelector('#custom-blend-intro');
        this.roast = this.querySelector('#roast');
        this.flavor = this.querySelector('#flavor');
        this.quantity = this.querySelector('#quantity');
        this.review = this.querySelector('#review');

        //Selectors 
        this.roastLevel = this.querySelector('#roast-range');

        //roast properties
        this.roastLight = this.querySelector('#roast-slider #light');
        this.roastLightMedium = this.querySelector('#roast-slider #light-medium'); 
        this.roastMedium = this.querySelector('#roast-slider #medium');
        this.roastMediumDark = this.querySelector('#roast-slider #medium-dark'); 
        this.roastDark = this.querySelector('#roast-slider #dark');

        this.roastLightImage = this.querySelector('#roast-light-image');
        this.roastLightMediumImage = this.querySelector('#roast-light-medium-image');
        this.roastMediumImage = this.querySelector('#roast-medium-image');
        this.roastMediumDarkImage = this.querySelector('#roast-medium-dark-image');
        this.roastDarkImage = this.querySelector('#roast-dark-image');

        this.roastLevelOne = this.querySelector('#roast-level-one');
        this.roastLevelTwo = this.querySelector('#roast-level-two');
        this.roastLevelThree = this.querySelector('#roast-level-three');

        //flavor properties
        this.flavorParents = this.querySelectorAll('.flavor-parent');
        this.flavorOptions = this.querySelectorAll('.flavor-options__option');
        this.flavorSelectedCount = 0;
        this.maxSelections = false;
        this.maxSelectionsError = this.querySelector('#flavor-options-error');
        this.closeErrors = this.querySelectorAll('.close-error');
        
        this.flavorWheel = this.querySelector('#flavor-wheel'); 
        this.wheelEntries = this.querySelectorAll('.wheel-entry');
        this.wheelContainer = this.querySelector('#flavor-wheel-container');
        this.showWheel = this.querySelector('#show-flavor-wheel');
        this.closeWheel = this.querySelector('#close-flavor-wheel');

        //Quantity properties
        this.quantityOptions = this.querySelectorAll('.quantity-option');

        //Review properties 
        this.name = this.querySelector('input[name="name"]');
        this.bagColor = this.querySelectorAll('input[name="bag-color"]');
        this.request = this.querySelector('textarea[name="request"]');
        this.whiteBagImage = this.querySelector('#white-bag-image');
        this.blackBagImage = this.querySelector('#black-bag-image');
        this.customBagBtn = this.querySelector('#custom-bag-button');

        //Add to cart form inputs 
        this.form = this.querySelector('.shopify-product-form');
        this.formId = this.querySelector('#product-form-id');
        this.formRoast = this.querySelector('#product-form-roast');
        this.formFlavor = this.querySelector('#product-form-flavor');
        this.formName = this.querySelector('#product-form-name');
        this.formRequest = this.querySelector('#product-form-request');

        //Add to cart modal 
        this.addToCartModal = this.querySelector('#custom-blend-add-to-cart-modal');
        this.designBtn = this.querySelector('#design-a-bag');
        this.continueBtn = this.querySelector('#continue-to-cart');

        //Summary elements
        this.summaryItemContainers = this.querySelectorAll('.summary-item-container');
        this.summaryEle = document.createElement('li');
        this.summaryEle.innerHTML = `<div class="summary-item summary-item--empty relative flex items-center justify-center h-[40px] w-[40px] lg:h-[64px] lg:w-[64px] rounded-[5px] bg-cream300 mx-1">
                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="plus">
                                    <path id="Icon" d="M7.5 3V13M12.5 8L2.5 8" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                            </svg>
                            <span class="tooltip hidden whitespace-nowrap absolute left-[5px] top-1/2 px-4 py-1 bg-neutral300 rounded-[4px] text-[.75rem] font-medium text-black500 z-10 opacity-0"></span>
                        </div>`;
        this.summaryItemOne = this.querySelectorAll('.summary-item-1');
    }
    
    connectedCallback() {
        this.attachEvents();

        this.beans.forEach(bean => {
            bean.classList.add('active');
        });

        setTimeout(() => {
            this.beans.forEach(bean => {
                bean.classList.add('floating');
            });
        }, 800);
    }
    
    // Event listeners
    attachEvents() {
        const _this = this;

        // this.enterBtn.addEventListener('click', () => {
        //     this.enterFlow();
        // });

        if (this.mobileSummaryToggle) {
            this.mobileSummaryToggle.addEventListener('click', () => {
                this.toggleMobileSummary();
            });
        }

        if (this.nextStep) {
            this.nextStep.addEventListener('click', () => {
                this.nextStepChange();
            });
        }

        if (this.previousStep) {
            this.previousStep.addEventListener('click', () => {
                this.previousStepChange();
            });
        }

        this.progressSteps.forEach(step => {
            step.addEventListener('click', () => {
                console.log(step);
                this.progressStepSelect(step);
            })
        });

        this.closeErrors.forEach(closeError => {
            closeError.addEventListener('click', () => {
                closeError.parentElement.classList.add('hidden');
            })
        });
        
        if (this.roastLevel) {
            this.roastLevel.addEventListener('change', () => {
                this.roastSelect(this.roastLevel.value);
            });

            this.roastLevel.addEventListener('keydown', (event) => {
                this.roastKeyboard(this.roastLevel.value,event);
            });
        }

        this.flavorParents.forEach(flavorParent => {
            flavorParent.addEventListener('click', () => {
                _this.flavorCategorySelect(flavorParent);
            })
        });

        this.flavorOptions.forEach(flavorOption => {
            flavorOption.addEventListener('click', () => {
                _this.flavorOptionSelect(flavorOption);
            })
        });

        if (this.showWheel && this.closeWheel && this.modalBackground && this.wheelContainer) {
            this.showWheel.addEventListener('click', () => {
                this.showWheel.setAttribute('aria-expanded', 'true');
                this.closeWheel.setAttribute('aria-expanded', 'true');
                this.modalBackground.classList.remove('hidden');
                this.wheelContainer.classList.add('active');
            });

            this.closeWheel.addEventListener('click', () => {
                this.showWheel.setAttribute('aria-expanded', 'false');
                this.closeWheel.setAttribute('aria-expanded', 'false');
                this.modalBackground.classList.add('hidden');
                this.wheelContainer.classList.remove('active');
            });
        }

        this.quantityOptions.forEach(quantityOption => {
            quantityOption.addEventListener('click', () => {
                _this.quantityOptionSelect(quantityOption);
            })
        });

        if (this.name) {
            this.name.addEventListener('input', () => {
                this.nameCheck();
            });
        }

        if (this.bagColor && this.bagColor.length) {
            this.bagColor.forEach(colorOption => {
                colorOption.addEventListener('change', () => {
                    this.changeBagColor(colorOption.value);
                })
            });
        }

        if (this.request && this.formRequest) {
            this.request.addEventListener('input', () => {
                this.formRequest.value = this.request.value;
            });
        }

        if (this.customBagBtn) {
            this.customBagBtn.addEventListener('click', () => {
                document.querySelector('#zakeke-product-button').click();
            });
        }

        if (this.designBtn) {
            this.designBtn.addEventListener('click', () => {
                document.querySelector('#zakeke-product-button').click();
            });
        }

        this.modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                this.openModal(trigger);
            })
        });

        this.closeModals.forEach(closeModal => {
            closeModal.addEventListener('click', () => {
                this.closeModal();
            })
        });

        if (this.startOver) {
            this.startOver.addEventListener('click', () => {
                window.location.reload();
            });
        }

        if (this.continueBtn) {
            this.continueBtn.addEventListener('click', () => {
                this.addToCart();
            });
        }
    }

    /**
     * The function `enterFlow` hides certain elements and adds classes to others to activate a
     * first step in a flow. 
     * We have removed the first step on client request but I am leaving the code in case of future changes.
     */
    // enterFlow() {
    //     this.intro.classList.add('hidden');
    //     this.announcmentBar.classList.add('hidden');
    //     this.siteHeader.classList.add('hidden');
    //     this.footer.classList.add('hidden');
    //     this.footerBorder.classList.add('hidden');
    //     this.style.paddingBottom = '0';
    //     this.classList.remove('bg-coffeegray200');
        
    //     this.stepsContainer.classList.add('active');
    //     this.header.classList.add('active');
    //     this.mobileSummary.classList.add('active');
    //     this.navigation.classList.add('active');
    //     this.progress.classList.add('active');

    //     this.roast.classList.add('active-step');
    // }

    /**
     * The `addToCart` function in JavaScript sends a POST request to add items to the shopping cart
     * with specified properties and handles the response accordingly.
     */
    addToCart() {
        let formData = {
            'items': [{
                'id': this.formId.value,
                'quantity': 1,
                properties: {
                    'Roast': this.formRoast.value,
                    'Flavors': this.formFlavor.value,
                }
             }]
        };

        if(this.formName.value.length > 0) {
            formData.items[0].properties['Name'] = this.formName.value;
        }
        if(this.formRequest.value.length > 0) {
            formData.items[0].properties['Special request'] = this.formRequest.value;
        }
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            console.log(response.json());
            window.location.href = '/?cart_open=true'
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    /**
     * The function `toggleMobileSummary` toggles the `aria-expanded` attribute and the `expanded`
     * class of an the mobile summary container.
     */
    toggleMobileSummary() {
        if(this.mobileSummary.getAttribute('aria-expanded') === 'true') {
            this.mobileSummary.setAttribute('aria-expanded', 'false');
            this.mobileSummary.classList.remove('expanded');
        } else {
            this.mobileSummary.setAttribute('aria-expanded', 'true');
            this.mobileSummary.classList.add('expanded');
        }
    }

    /**
     * The function `nextStepChange` progresses through different steps of the custom blend creation
     * process based on the current active step.
     */
    nextStepChange() {
        const currentStep = this.querySelector('.custom-blend__step.active-step');

        switch(currentStep.id) {
            case 'roast':
                this.roast.classList.remove('active-step');
                this.roast.classList.add('step-complete');
                this.stepOneTitle.classList.add('step-complete');
                this.flavor.classList.add('active-step');
                this.querySelector('#flavor-parent-fruity').focus();
                this.stepOneTitle.classList.add('opacity-25');
                this.stepOneTitle.classList.remove('font-bold');
                this.stepTwoTitle.classList.remove('opacity-25');
                this.stepTwoTitle.classList.add('font-bold');
                this.previousStep.classList.remove('opacity-0');
                this.previousStep.disabled = false;
                if(!this.flavor.classList.contains('step-complete')) {
                    this.nextStep.disabled = true;
                }
                this.addEmptyItem();
                this.checkProgress('flavor');
                break;
            case 'flavor':
                this.flavor.classList.remove('active-step');
                this.flavor.classList.add('step-complete');
                this.stepTwoTitle.classList.add('step-complete');
                this.quantity.classList.add('active-step');
                this.querySelector('.quantity-option').focus();
                this.stepTwoTitle.classList.add('opacity-25');
                this.stepTwoTitle.classList.remove('font-bold');
                this.stepThreeTitle.classList.remove('opacity-25');
                this.stepThreeTitle.classList.add('font-bold');
                this.progressFill.style.width = '90%';
                if(!this.quantity.classList.contains('step-complete')) {
                    this.nextStep.disabled = true;
                }
                if(document.querySelector('.summary-item.quantity-selected')) {
                    this.removeEmptyItem();
                } else if(document.querySelector('.summary-item--empty')) {
                    this.removeEmptyItem();
                    this.addEmptyItem();
                } else {
                    this.addEmptyItem();
                }
                this.checkProgress('quantity');
                break;
            case 'quantity':
                this.quantity.classList.remove('active-step');
                this.quantity.classList.add('step-complete');
                this.stepThreeTitle.classList.add('step-complete');
                this.review.classList.add('active-step');
                this.name.focus();
                this.stepThreeTitle.classList.add('opacity-25');
                this.stepThreeTitle.classList.remove('font-bold');
                this.stepFourTitle.classList.remove('opacity-25');
                this.stepFourTitle.classList.add('font-bold');
                this.nextStep.disabled = true;
                this.nextText.classList.add('hidden');
                this.addToCartText.classList.remove('hidden');
                this.nameCheck();
                break;
            case 'review':
                this.addToCart();
                break;
        }
    }



    /**
     * The function `previousStepChange` handles the logic for changing active steps in the multi-step
     * custom blend creation process.
     */
    previousStepChange() {
        const currentStep = this.querySelector('.custom-blend__step.active-step');

        switch(currentStep.id) {
            case 'flavor':
                this.flavor.classList.remove('active-step');
                this.roast.classList.add('active-step');
                this.roastLevel.focus();
                this.stepTwoTitle.classList.add('opacity-25');
                this.stepTwoTitle.classList.remove('font-bold');
                this.stepOneTitle.classList.remove('opacity-25');
                this.stepOneTitle.classList.add('font-bold');
                this.nextStep.disabled = false;
                this.previousStep.classList.add('opacity-0');
                this.previousStep.disabled = true;
                this.removeEmptyItem();
                break;
            case 'quantity':
                this.quantity.classList.remove('active-step');
                this.flavor.classList.add('active-step');
                this.querySelector('#flavor-parent-fruity').focus();
                this.stepThreeTitle.classList.add('opacity-25');
                this.stepThreeTitle.classList.remove('font-bold');
                this.stepTwoTitle.classList.remove('opacity-25');
                this.stepTwoTitle.classList.add('font-bold');
                this.nextStep.disabled = false;
                if(this.flavorSelectedCount >= 3 && document.querySelector('.summary-item--empty')) {
                    this.removeEmptyItem();
                } else if(this.flavorSelectedCount < 3 && !document.querySelector('.summary-item--empty')) {
                    this.addEmptyItem();
                }
                break;
            case 'review':
                this.review.classList.remove('active-step');
                this.quantity.classList.add('active-step');
                this.querySelector('.quantity-option').focus();
                this.stepFourTitle.classList.add('opacity-25');
                this.stepFourTitle.classList.remove('font-bold');
                this.stepThreeTitle.classList.remove('opacity-25');
                this.stepThreeTitle.classList.add('font-bold');
                this.addToCartText.classList.add('hidden');
                this.nextText.classList.remove('hidden');

                if(document.querySelector('.summary-item.quantity-selected')) {
                    this.nextStep.disabled = false;
                } else {
                    this.nextStep.disabled = true;
                }
                break;
        }
    }

    /**
     * The function `progressStepSelect` handles the progression of steps in a custom blend creation
     * process based on user interactions.
     * @param step - The `step` parameter in the `progressStepSelect` function represents the current
     * step element that is being selected or clicked on. The function checks if the step has a class
     * of 'step-complete' and if it is not already the active step. If these conditions are met, the
     * function proceeds to
     */
    progressStepSelect(step) {
        if(step.classList.contains('step-complete')) {
            if(!step.classList.contains('active-step')) {
                const currentStep = this.querySelector('.custom-blend__step.active-step');
                const currentStepTitle = this.querySelector('.progress-step.font-bold');

                currentStep.classList.remove('active-step');
                currentStepTitle.classList.add('opacity-25');
                currentStepTitle.classList.remove('font-bold');
                
                step.classList.remove('opacity-25');
                step.classList.add('font-bold');
                
                switch(step.dataset.stepTitle) {
                    case 'roast':
                        this.roast.classList.add('active-step');
                        this.roastLevel.focus();
                        this.nextStep.disabled = false;
                        this.previousStep.classList.add('opacity-0');
                        this.previousStep.disabled = true;
                        this.removeEmptyItem();
                        break;
                    case 'flavor':
                        this.flavor.classList.add('active-step');
                        this.querySelector('#flavor-parent-fruity').focus();
                        this.nextStep.disabled = false;
                        this.previousStep.classList.remove('opacity-0');
                        this.previousStep.disabled = false;
                        if(this.flavorSelectedCount >= 3 && document.querySelector('.summary-item--empty')) {
                            this.removeEmptyItem();
                        } else if(this.flavorSelectedCount < 3 && !document.querySelector('.summary-item--empty')) {
                            this.addEmptyItem();
                        }
                        break;
                    case 'quantity':
                        this.quantity.classList.add('active-step');
                        this.querySelector('.quantity-option').focus();
                        this.addToCartText.classList.add('hidden');
                        this.nextText.classList.remove('hidden');
                        this.previousStep.classList.remove('opacity-0');
                        this.previousStep.disabled = false;
        
                        if(document.querySelector('.summary-item.quantity-selected')) {
                            this.nextStep.disabled = false;
                            this.removeEmptyItem();
                        } else {
                            this.nextStep.disabled = true;
                            if(!document.querySelector('.summary-item--empty')) {
                                this.addEmptyItem();
                            }
                        }
                        break;
                }
            }
        }
    }

    /**
     * The `addEmptyItem` function clones a summary element and appends it to both summary containers.
     */
    addEmptyItem() {
        this.summaryItemContainers.forEach(container => {
            // Clone the <li> template you built in the constructor
            const newSummaryEle = this.summaryEle.cloneNode(true);
            // Append it as the last child of the <ul>
            container.appendChild(newSummaryEle);
        });
    }

    /**
     * The `removeEmptyItem` function removes elements with the class `summary-item--empty` from each
     * container in the `summaryItemContainers` array.
     */
    removeEmptyItem() {
        this.summaryItemContainers.forEach(container => {
            if(container.querySelector('.summary-item--empty')) {
                container.querySelector('.summary-item--empty').remove();
            }
        });
    }

    /**
     * The function `roastSelect` determines the roast option based on a given value and updates the UI
     * accordingly.
     * @param value - The `roastSelect` function takes a `value` parameter as input to determine the
     * roast option based on the value provided. The function then sets the appropriate roast option
     * and updates the UI accordingly.
     */
    roastSelect(value) {
        if (value > 0 && value <= 20) {
            this.setRoastOption('light', this.roastLight, 6, this.roastLightImage, this.roastLevelOne);
        } else if (value > 20 && value <= 40) {
            this.setRoastOption('light-medium', this.roastLightMedium, 25, this.roastLightMediumImage, this.roastLevelOne);
        } else if (value > 40 && value <= 60) {
            this.setRoastOption('medium', this.roastMedium, 50, this.roastMediumImage, this.roastLevelTwo);
        } else if (value > 60 && value <= 80) {
            this.setRoastOption('medium-dark', this.roastMediumDark, 76, this.roastMediumDarkImage, this.roastLevelThree);
        } else if (value > 80 && value <= 100) {
            this.setRoastOption('dark', this.roastDark, 100, this.roastDarkImage, this.roastLevelThree);
        } else {
            value = 0;
        }

        if (value > 0) {
            this.nextStep.disabled = false;
            this.roast.classList.remove('step-complete');
            if(this.querySelector('.summary-item--empty')) {
                if(document.querySelector('.summary-item.flavor-selected') && document.querySelector('.summary-item.quantity-selected')) {
                    this.progressFill.style.width = '80%';
                } else if(document.querySelector('.summary-item.flavor-selected') || document.querySelector('.summary-item.quantity-selected')) {
                    this.progressFill.style.width = '60%';
                } else {
                    this.progressFill.style.width = '20%';
                }
                this.toggleComplete(false);
            } else {
                if(document.querySelector('.summary-item.flavor-selected') && document.querySelector('.summary-item.quantity-selected')) {
                    this.progressFill.style.width = '100%';
                    this.toggleComplete(true);
                }  else {
                    this.progressFill.style.width = '20%';
                    this.toggleComplete(false);
                }
            }
            this.summaryItemOne.forEach(item => {
                item.querySelector('svg').classList.add('hidden');
                item.querySelector('.tooltip').classList.remove('hidden');
            });
            this.summaryCount.innerText = Number(this.summaryCount.innerText) + 1;
        } else {
            this.nextStep.disabled = true;
            this.progressFill.style.width = '0%';
            this.summaryItemOne.forEach(item => {
                item.querySelector('svg').classList.remove('hidden');
                item.querySelector('.tooltip').classList.add('hidden');
            });
            this.summaryCount.innerText = Number(this.summaryCount.innerText) - 1;
            this.toggleComplete(false);
        }
    }

    /**
     * The function `setRoastOption` updates the roast level, image, and selected state based on user
     * input.
     * @param roast - The `roast` parameter in the `setRoastOption` function represents the type or
     * level of roast selected by the user. It is used to update the roast value in the form and
     * display the selected roast image and tooltip text.
     * @param roastEle - `roastEle` is a DOM element representing a roast option that the user has
     * selected.
     * @param sliderValue - The `sliderValue` parameter in the `setRoastOption` function represents the
     * value selected on a slider input element. This value is used to update the roast level in the UI
     * when a user interacts with the slider.
     * @param roastImageElement - The `roastImageElement` parameter in the `setRoastOption` function is
     * used to specify the element that represents the roast image. This element will have the class
     * `roast-image` and will be updated to display the active image corresponding to the selected
     * roast option.
     */
    setRoastOption(roast, roastEle, sliderValue, roastImageElement, roastSubText) {
        this.roastLevel.value = sliderValue;
        this.formRoast.value = roast;
        this.summaryItemOne.forEach(item => {
            item.style.background = 'url("' + roastEle.dataset.image + '")';
            item.dataset.roast = roast.replace('-', ' ');
            item.classList.add('filled')

            item.querySelector('.tooltip').innerText = roast.replace('-', ' ');
        });

        if(this.querySelector('.roast-option.selected')) {
            this.querySelector('.roast-option.selected').classList.remove('selected');
        }
        roastEle.classList.add('selected');

        if(this.querySelector('.roast-image.active-image')) {
            this.querySelector('.roast-image.active-image').classList.remove('active-image');
        }
        roastImageElement.classList.add('active-image');
        
        if(this.querySelector('.roast-subtext.active-level')) {
            this.querySelector('.roast-subtext.active-level').classList.remove('active-level');
        }
        roastSubText.classList.add('active-level');
    }

    /**
     * The function `roastKeyboard` handles keyboard events for selecting roast values in a specific
     * sequence.
     * @param value - The `value` parameter in the `roastKeyboard` function represents the current
     * value of a roast selection. It is used to determine the next roast selection based on the
     * keyboard event received (ArrowRight or ArrowLeft). The function increments or decrements the
     * roast selection value based on the current value and
     * @param event - The `event` parameter in the `roastKeyboard` function is an object that
     * represents the event triggered by a keyboard input. It contains information about the key that
     * was pressed, such as `event.key`, which indicates the key that was pressed (e.g., 'ArrowRight'
     * or 'Arrow
     */
    roastKeyboard(value,event) {
        if(event.key === 'ArrowRight') {
            switch(value) {
                case '0':
                    this.roastSelect(6);
                    break;
                case '6':
                    this.roastSelect(25);
                    break;
                case '25':
                    this.roastSelect(50);
                    break;
                case '50':
                    this.roastSelect(76);
                    break;
                case '76':
                    this.roastSelect(100);
                    break;
            }
        } else if(event.key === 'ArrowLeft') {
            switch(value) {
                case '6':
                    this.roastSelect(0);
                    break;
                case '25':
                    this.roastSelect(6);
                    break;
                case '50':
                    this.roastSelect(25);
                    break;
                case '76':
                    this.roastSelect(50);
                    break;
                case '100':
                    this.roastSelect(76);
                    break;
            }
        }
    }

    /**
     * The function `flavorCategorySelect` is used to handle the selection of flavor categories by
     * adding and removing classes to show/hide options.
     * @param flavorParent - The `flavorParent` parameter in the `flavorCategorySelect` function
     * represents the parent element of a flavor category. This function is designed to handle the
     * selection of a flavor category and manage the visibility of its options container based on user
     * interaction.
     */
    flavorCategorySelect(flavorParent) {
        const optionsContainer = flavorParent.getAttribute('aria-controls');
        if(!this.querySelector('#' + optionsContainer).classList.contains('active')) {
            if(this.querySelector('.flavor-parent.selected')) {
                this.querySelector('.flavor-parent.selected').classList.remove('selected');
            }

            if(this.querySelector('.flavor-options.active')) {
                this.querySelector('.flavor-options.active').classList.remove('active');
            }

            flavorParent.classList.add('selected');
            const flavorOptions = this.querySelector('#' + optionsContainer);
            flavorOptions.classList.add('active');
            flavorOptions.querySelector('.flavor-options__option').focus();
        }
    }

    /**
     * The function `flavorOptionSelect` is used to handle the selection or deselection of flavor options.
     * @param flavorOption - The `flavorOption` parameter in the `flavorOptionSelect` function
     * represents the specific flavor option that the user has selected.
     */
    flavorOptionSelect(flavorOption) {
        // 1) Find the corresponding parent-flavor element inside this component
        const parentFlavorOption = this.querySelector(
            `.flavor-options__parent[data-flavor="${flavorOption.dataset.parentFlavor}"]`
        );
        
        if (flavorOption.classList.contains('selected')) {
            // —— DESELECT ——  
            flavorOption.classList.remove('selected');
        
            // Remove its thumbnails from the summary
            const summaryItems = this.querySelectorAll(
            `.summary-item[data-flavor="${flavorOption.dataset.flavor}"]`
            );
            this.removeSummaryFlavor(flavorOption, summaryItems);
        
            // Decrement our selection count
            this.flavorSelectedCount--;
        
            // Re-enable other options if we’re back under the limit
            if (this.flavorSelectedCount < 3) {
            this.flavorOptions.forEach(o => o.classList.remove('disabled'));
            this.maxSelections = false;
            }
        
            // If nothing is selected at all, hide the flavor wheel
            if (this.flavorSelectedCount === 0 && this.flavorWheel) {
            this.flavorWheel.classList.remove('active');
            }
        
            // Unmark the parent category as “has a selection”
            if (parentFlavorOption) {
            parentFlavorOption.classList.remove('child-selected');
            }
        
        } else {
            // —— SELECT ——
            // Prevent selecting more than 3
            if (this.flavorSelectedCount >= 3 || flavorOption.classList.contains('disabled')) {
            this.maxSelectionsError.classList.remove('hidden');
            return;
            }
        
            // Mark this flavor option as selected
            flavorOption.classList.add('selected');
        
            // 2) Append one blank slot at the end of each summary list
            this.addEmptyItem();
        
            // 3) Gather only those newly added slots
            const newSlots = [];
            this.summaryItemContainers.forEach(container => {
            const empties = container.querySelectorAll('.summary-item--empty');
            newSlots.push(empties[empties.length - 1]);
            });
        
            // 4) Fill each new slot with this flavor’s thumbnail & tooltip
            this.setSummaryFlavor(flavorOption, newSlots);
        
            // Increment our selection count
            this.flavorSelectedCount++;
        
            // Mark the parent category as “has a selection”
            if (parentFlavorOption) {
            parentFlavorOption.classList.add('child-selected');
            }
        
            // If we’ve reached 3, disable all other flavor options
            if (this.flavorSelectedCount >= 3) {
            this.flavorOptions.forEach(o => {
                if (!o.classList.contains('selected')) {
                o.classList.add('disabled');
                }
            });
            this.maxSelections = true;
            this.checkProgress();
            }
        }
        
        // 5) Move the one empty placeholder <li> to the very end,
        //    so it never sits between real flavor thumbnails.
        this.summaryItemContainers.forEach(container => {
            const placeholder = container.querySelector('.summary-item--empty');
            if (!placeholder) return;
            const li = placeholder.closest('li');
            container.appendChild(li);
        });
        
        // 6) Update the Next button’s enabled state and the progress bar
        if (this.flavorSelectedCount > 0) {
            this.nextStep.disabled = false;
            switch (this.flavorSelectedCount) {
            case 1:
                this.progressFill.style.width = '40%';
                break;
            case 2:
                this.progressFill.style.width = '60%';
                break;
            case 3:
                this.progressFill.style.width = '90%';
                this.checkProgress();
                break;
            }
        } else {
            this.nextStep.disabled = true;
            this.progressFill.style.width = '20%';
            this.flavor.classList.remove('step-complete');
        }
    }

    /**
     * The function `removeSummaryFlavor` removes a selected flavor option from the summary items and
     * updates their display accordingly.
     * @param flavorOption - The `flavorOption` parameter is a specific flavor option that the user has
     * selected for removal from the summary items.
     * @param summaryItems - An array of HTML elements representing summary items in a product form.
     */
    removeSummaryFlavor(flavorOption, summaryItems) {
        const emptyCount = document.querySelectorAll('#navigation-container .summary-item--empty').length;
        if(this.flavorSelectedCount < 3 || emptyCount > 0) {
            this.removeEmptyItem();
        }
        
        this.formFlavor.value = this.formFlavor.value.replace(`${flavorOption.dataset.flavor}, `, '');
        
        this.querySelector('.wheel-entry[data-flavor="' + flavorOption.dataset.flavor + '"]').classList.remove('selected');
        summaryItems.forEach(item => {
            item.style.background = 'none';
            item.dataset.flavor = '';
            item.dataset.parentFlavor = '';
            item.querySelector('.tooltip').innerText = '';
            item.querySelector('.tooltip').classList.add('hidden');
            item.classList.remove('filled');
            item.classList.remove('flavor-selected');
            item.classList.add('summary-item--empty')
            item.querySelector('svg').classList.remove('hidden');
        });

        this.toggleComplete(false);

        this.summaryCount.innerText = Number(this.summaryCount.innerText) - 1;
    }

    /**
     * The function `setSummaryFlavor` dynamically updates the form and visual elements based on the
     * selected flavor option.
     * @param flavorOption - The `flavorOption` parameter in the `setSummaryFlavor` function represents
     * an element that contains data related to a flavor option. It seems to be a DOM element with
     * various dataset attributes such as `flavor`, `image`, `title`, and `parentFlavor`. This function
     * is
     * @param emptyItems - The `emptyItems` parameter in the `setSummaryFlavor` function is an array of
     * HTML elements representing items that need to be filled with information related to a selected
     * flavor option. These items are updated with the flavor information and styling based on the
     * selected flavor option.
     */
    setSummaryFlavor(flavorOption, emptyItems) {
        this.formFlavor.value = this.formFlavor.value + flavorOption.dataset.flavor + ', ';

        this.flavorWheel.classList.add('active');
        this.querySelector('.wheel-entry[data-flavor="' + flavorOption.dataset.flavor + '"]').classList.add('selected');

        emptyItems.forEach(item => {
            item.style.background = 'url("' + flavorOption.dataset.image + '")';
            item.dataset.flavor = flavorOption.dataset.flavor;
            if(flavorOption.dataset.parentFlavor !== flavorOption.dataset.flavor) {
                item.dataset.parentFlavor = flavorOption.dataset.parentFlavor;
            }
            item.querySelector('.tooltip').innerText = flavorOption.dataset.title;
            item.querySelector('.tooltip').classList.remove('hidden');
            item.classList.add('filled');
            item.classList.add('flavor-selected');
            item.classList.remove('summary-item--empty')
            item.querySelector('svg').classList.add('hidden');
        });

        this.summaryCount.innerText = Number(this.summaryCount.innerText) + 1;
    }

    
    /**
     * The function `quantityOptionSelect` toggles the selection of a quantity option element within a
     * container.
     * @param quantityOption - The `quantityOptionSelect` function takes a parameter `quantityOption`,
     * which is a reference to an HTML element representing a quantity option. The function checks if
     * the quantity option is already selected. If it is selected, it removes the selection. If another
     * quantity option is already selected, it first removes that
     */
    quantityOptionSelect(quantityOption) {
        if(quantityOption.classList.contains('selected')) {
            this.removeQuantityOption(quantityOption);
        } else if (this.querySelector('.quantity-option.selected')) {
            this.removeQuantityOption(this.querySelector('.quantity-option.selected'));
            this.addQuantityOption(quantityOption);
        } else { 
            this.addQuantityOption(quantityOption);
        }
    }

    /**
     * The function `removeQuantityOption` removes a selected quantity option and resets related
     * elements in a web application.
     * @param quantityOption - The `quantityOption` parameter in the `removeQuantityOption` function
     * represents an HTML element that corresponds to a quantity option in a form. This function is
     * designed to remove the selected quantity option and reset associated elements and styles.
     */
    removeQuantityOption(quantityOption) {
        const summaryItems = this.querySelectorAll(`.summary-item[data-quantity="${quantityOption.dataset.quantity}"]`);
        this.formId.value = '';
        summaryItems.forEach(item => {
            item.style.background = 'none';
            item.dataset.quantity = '';
            item.querySelector('.tooltip').innerText = '';
            item.querySelector('.tooltip').classList.add('hidden');
            item.classList.remove('filled');
            item.classList.add('summary-item--empty')
            item.querySelector('svg').classList.remove('hidden');
            item.classList.remove('quantity-selected');
        });
        quantityOption.classList.remove('selected');

        this.subtotalContainers.forEach(container => {
            container.classList.add('hidden');
        });

        this.quantityOptions.forEach(option => {
            option.classList.remove('disabled')
        });

        this.nextStep.disabled = true;
        this.progressFill.style.width = '90%';
        this.quantity.classList.remove('step-complete');
        this.toggleComplete(false);
        this.summaryCount.innerText = Number(this.summaryCount.innerText) - 1;
    }

    /**
     * The `addQuantityOption` function updates the display and data attributes based on the selected
     * quantity option, enabling further actions in a shopping cart interface.
     * @param quantityOption - The `quantityOption` parameter in the `addQuantityOption` function
     * represents an option for selecting the quantity of a particular item. It contains various data
     * attributes such as `dataset.image`, `dataset.quantity`, and `dataset.title` which are used to
     * update the display of the selected quantity option in the
     */
    addQuantityOption(quantityOption) {
        const emptyItems = this.querySelectorAll('.summary-item--empty');
        emptyItems.forEach(item => {
            item.style.background = 'url("' + quantityOption.dataset.image + '")';
            item.dataset.quantity = quantityOption.dataset.quantity;
            item.querySelector('.tooltip').innerText = quantityOption.dataset.title;
            item.querySelector('.tooltip').classList.remove('hidden');
            item.classList.add('filled');
            item.classList.remove('summary-item--empty')
            item.querySelector('svg').classList.add('hidden');
            item.classList.add('quantity-selected');
        });

        quantityOption.classList.add('selected');
        
        const bagColorInput = this.querySelector('input[name="bag-color"]:checked');
        const bagColor = bagColorInput ? bagColorInput.value : '';
        // Find variant by combined color/title, otherwise fall back to title-only variants (new SKU naming)
        const variantOption = this.querySelector(`.product-variant__id[name='${bagColor} / ${quantityOption.dataset.title}']`) 
            || this.querySelector(`.product-variant__id[name='${quantityOption.dataset.title}']`);
        const variantId = variantOption ? variantOption.value : '';
        const variantPrice = variantOption ? variantOption.dataset.price : '';
        this.formId.value = variantId;

        if(variantPrice) {
            this.summaryTotal.forEach(total => {
                total.innerText = `${variantPrice}`;
            });
        }

        this.subtotalContainers.forEach(container => {
            container.classList.remove('hidden');
        });

        this.quantityOptions.forEach(option => {
            if(!option.classList.contains('selected')) {
                option.classList.add('disabled')
            }
        });

        this.nextStep.disabled = false;
        this.progressFill.style.width = '100%';
        this.toggleComplete(true);
        this.summaryCount.innerText = Number(this.summaryCount.innerText) + 1;
    }

    /**
     * The function `nameCheck` updates a form field with the value of another field and enables or
     * disables a button based on the length of the input in the field.
     */
    nameCheck() {
        this.formName.value = this.name.value;

        if(this.name.value.length > 0) {
            this.nextStep.disabled = false;
        } else {
            this.nextStep.disabled = true;
        }
    }

    /**
     * The function `changeBagColor` changes the color of a bag image based on the input color and
     * updates the variant ID value in a form accordingly.
     * @param color - The `color` parameter in the `changeBagColor` function represents the color of
     * the bag that you want to change to. It is used to determine whether to show the white bag image
     * or the black bag image based on the color selected.
     */
    changeBagColor(color) {
        if(color === 'White') {
            this.blackBagImage.classList.add('hidden');
            this.whiteBagImage.classList.remove('hidden');
        } else {
            this.blackBagImage.classList.remove('hidden');
            this.whiteBagImage.classList.add('hidden');
        }

        const selectedOption = this.querySelector('.quantity-option.selected');
        if(!selectedOption) return;

        const selectedOptionName = selectedOption.dataset.title;
        const selectedVariant = this.querySelector(`.product-variant__id[name='${color} / ${selectedOptionName}']`) 
            || this.querySelector(`.product-variant__id[name='${selectedOptionName}']`);
        if(selectedVariant) {
            this.formId.value = selectedVariant.value;
        }
    }

    /**
     * The `openModal` function is used to display a modal by removing the 'hidden' class and adding
     * the 'active-modal' class to the modal element, updating the 'aria-expanded' attribute of the
     * target element, and removing the 'hidden' class from the modal background.
     * @param target - The `target` parameter in the `openModal` function is typically a reference to
     * the element that triggered the modal to open. It is used to identify which modal should be
     * opened based on the `aria-controls` attribute of the target element.
     */
    openModal(target) {
        const modal = document.getElementById(target.getAttribute('aria-controls'));
        modal.classList.remove('hidden');
        modal.classList.add('active-modal');
        target.setAttribute('aria-expanded', true);
        this.modalBackground.classList.remove('hidden');
    }

    /**
     * The function closeModal hides the active modal and its background.
     */
    closeModal() {
        const modal = this.querySelector('.active-modal');
        modal.classList.add('hidden');
        modal.classList.remove('active-modal');
        this.modalBackground.classList.add('hidden');
    }

    /**
     * The `toggleComplete` function toggles the visibility of progress elements based on the value of
     * the `complete` parameter.
     * @param complete - The `complete` parameter is a boolean value that indicates whether a task or
     * process is complete (`true`) or still in progress (`false`). The `toggleComplete` function uses
     * this parameter to show or hide elements on the page based on the completion status.
     */
    toggleComplete(complete) {
        if(complete === true) {
            this.progressComplete.classList.remove('hidden');
            this.progressBrewing.classList.add('hidden');
            this.progressFill.style.width = '100%';
        } else {
            this.progressComplete.classList.add('hidden');
            this.progressBrewing.classList.remove('hidden');
        }
    }

    /**
     * The function `checkProgress` checks for selected flavor and quantity items and updates the
     * progress bar accordingly.
     * @param context - The `context` parameter in the `checkProgress` function is used to determine
     * whether the progress check is related to selecting a flavor or selecting a quantity. Depending
     * on the value of `context`, the function enables the next step button if the corresponding item
     * has been selected.
     */
    checkProgress(context) {
        if(document.querySelector('.summary-item.flavor-selected') && document.querySelector('.summary-item.quantity-selected') && document.querySelector('.summary-item-1').classList.contains('filled')) {
            this.toggleComplete(true);
            this.progressFill.style.width = '100%';
        }

        if(context === 'flavor') {
            if(document.querySelector('.summary-item.flavor-selected')) {
                this.nextStep.disabled = false;
            }
        } else if(context === 'quantity') {
            if(document.querySelector('.summary-item.quantity-selected')) {
                this.nextStep.disabled = false;
            }
        }
    }
}

customElements.define('custom-blend', CustomBlend)